import { mapMutations, mapState } from "vuex";
import CourseService from "../../services/course";

import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue"
import { VueEditor } from "vue2-editor";
import { contractDefault, typesInstallment } from "../../common";
import { convertFileToBase64 } from "../../utils/convertFileToBase64"
import notImg from "../../assets/notImg.png";

import { mascaraMoeda, maskCurrency, maskPercentage } from "../../utils/maskMoney"
import moment from "moment";

const mixinCourse = {
  props: {
    clearAll: {
      type: Boolean,
    },
  },
  components: {
    InputSelect,
    VueEditor,
  },
  data() {
    return {
      dataCourse: {
        id: "",
        name: "",
        description: "",
        price: "",
        materialPrice: "",
        materialPriceOmega: "",
        duration: "",
        studantsLimit: "",
        startDate: "",
        endDate: "",
        periodo: "",
        pricingTotal: "",
        qtdInstallments: 1,
        pricingInstallments: "",
        pix: "",
        qtdInstallmentsMaterialOmega: 1,
        pricingInstallmentsMaterialOmega: "",
        referenceCourses: [],
      },
      urlPhoto: "",
      getCourse: false,
      confirmDelete: false,
      confirmStart: false,
      spinLoadingActionsButton: false,
      spinGeneral: false,
      maskCurrency: maskCurrency,
      mascaraMoeda: mascaraMoeda,
      isInvalidInput: "",
      maskPercentage: maskPercentage,
      selectedRadio: "",
      isOpen: false,
      editorContent: contractDefault,
      typesInstallment: typesInstallment,
      toolbarOptions: [
        ["bold", "italic", "underline", "strikeThrough"],
        [{ align: [] }],
        ["link", "image"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
      fonts: {
        arial: "Arial",
        times_new_roman: "Times New Roman",
        verdana: "Verdana",
      },
      imgBase64: null,
      textLogo: "Click me",
      classImg: "logo_img",
      notImg: notImg,
    };
  },

  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_COURSE",
    ]),
    clearInputs() {
      this.SET_DATA_SEARCH_FROM_COURSE({})
    },
    toggleEditor() {
      this.isOpen = !this.isOpen;
    },
    async selectImage(e) {
      const base64 = await convertFileToBase64(e.target.files[0]);
      this.imgBase64 = base64;
      this.urlPhoto = base64

      this.classImg = "logo_img_not";
    },

    updateCourseInstallmentValue() {
      if (this.dataCourse.price > 0 && this.dataCourse.qtdInstallments > 0) {
        this.dataCourse.pricingInstallments =
          (this.dataCourse.price / this.dataCourse.qtdInstallments).toFixed(2);
      }
    },
    updateMaterialInstallmentValue() {
      if (this.dataCourse.materialPriceOmega > 0 && this.dataCourse.qtdInstallmentsMaterialOmega > 0) {
        this.dataCourse.pricingInstallmentsMaterialOmega =
          (this.dataCourse.materialPriceOmega / this.dataCourse.qtdInstallmentsMaterialOmega).toFixed(2);
      }
    },
    saveOrUpdateCourse() {
      if (this.dataCourse.id === "") return this.saveCourse();

      this.updateCourse();
    },

    async saveCourse() {
      try {
        const { startDate, endDate } = this.dataCourse;

        if (startDate && endDate) {
          const start = moment(startDate);
          const end = moment(endDate);

          if (end.isBefore(start)) {
            return this.$toast.open({
              message: "A data final não pode ser anterior à data inicial.",
              type: "error",
            });
          }

          const duration = end.diff(start, "days");
          this.dataCourse.duration = `${duration} dias`;
        } else {
          return this.$toast.open({
            message: "As datas de início e fim são obrigatórias.",
            type: "error",
          });
        }
        const id = await CourseService.saveCourse(this.dataCourse);
        this.dataCourse.id = id;

        const contract = {
          courseId: this.dataCourse.id,
          data: this.editorContent,
          studentId: -1
        };

        await CourseService.saveContract(contract);

        this.clearInputs();
        return this.$toast.open({
          message: "Curso salvo com Sucesso",
          type: "success",
        });
      } catch (errors) {
        console.log(errors)
        const message = errors[0];
        this.$toast.open({
          message: message,
          type: "info",
        });
      }
    },

    async updateCourse() {
      const { startDate, endDate } = this.dataCourse;

      if (startDate && endDate) {
        const start = moment(startDate);
        const end = moment(endDate);

        if (end.isBefore(start)) {
          return this.$toast.open({
            message: "A data final não pode ser anterior à data inicial.",
            type: "error",
          });
        }

        const duration = end.diff(start, "days");
        this.dataCourse.duration = `${duration} dias`;
      } else {
        return this.$toast.open({
          message: "As datas de início e fim são obrigatórias.",
          type: "error",
        });
      }

      try {
        await CourseService.updateCourse(this.dataCourse, this.dataCourse.id);
        await CourseService.updateContract(this.dataCourse.id, this.editorContent);
        if (this.urlPhoto) {
          await CourseService.uploadFile(
            this.urlPhoto,
            this.imageName,
            this.dataCourse.id,
          );
        }
        this.clearInputs();
        this.$toast.open({
          message: "Curso atualizado com Sucesso",
          type: "success",
        });
      } catch (errors) {
        console.log(errors)
        const message = errors;
        this.$toast.open({
          message: message,
          type: "info",
        });

      }
    },

    gerarPix() {
      window.open('https://geradordepix.com/', '_blank');
    },

    handleFocus(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].focus();
        this.isInvalidInput = "isInvalidInput";
      }
    },

    clearInvalidInput() {
      this.isInvalidInput = "";
    },

    assingEditCourse() {
      Object.assign(this.dataCourse, this.dataSearchCourse)
      this.urlPhoto = this.dataSearchCourse.url
    },

    openModals(idModal) {
      this.$bvModal.show(idModal)
    },

    openDelete() {
      this.$bvModal.show("modal-close");
    },

    openStart() {
      this.$bvModal.show("modal-start");
    },

    async finishCourse() {
      try {
        await CourseService.finishCourse(this.dataCourse.id);

        this.clearInputs();
        this.$toast.open({
          message: "Curso finalizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Erro ao finalizar",
          type: "info",
        });
      }
    },

    async startCourse() {
      try {
        await CourseService.startCourse(this.dataCourse.id);

        this.clearInputs();
        this.$toast.open({
          message: "Curso iniciado com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Erro ao iniciar",
          type: "info",
        });
      }
    },

    assingpricingTotal(event) {
      this.dataCourse.pricingTotal = mascaraMoeda(event.target.value)
    },
    assingprice(event) {
      this.dataCourse.price = mascaraMoeda(event.target.value)
    },
    assingpricingInstallments(event) {
      this.dataCourse.pricingInstallments = mascaraMoeda(event.target.value)
    },
    assingmaterialPriceOmega(event) {
      this.dataCourse.materialPriceOmega = mascaraMoeda(event.target.value)
    },
    assingmaterialPrice(event) {
      this.dataCourse.materialPrice = mascaraMoeda(event.target.value)
    },
    assingpricingInstallmentsMaterialOmega(event) {
      this.dataCourse.pricingInstallmentsMaterialOmega = mascaraMoeda(event.target.value)
    },
    async lookAtContract() {
      try {
        const contractReturned = await CourseService.getContractByCourse(-1, this.dataSearchCourse.id)
        return contractReturned
      } catch (error) {
        return false
      }
    }
  },
  async mounted() {
    if (this.dataSearchCourse.id) {
      const contract = await this.lookAtContract()    
      if (contract.data.data) {  
        this.editorContent = contract.data.data.data;
      }

      this.assingEditCourse();
    }
  },
  computed: {
    ...mapState({
      dataSearchCourse: (state) => state.dataSearchCourse,
    }),
  },
  watch: {
    "dataCourse.qtdInstallments"() {
      this.updateCourseInstallmentValue();
    },
    "dataCourse.price"() {
      this.updateCourseInstallmentValue();
    },
    "dataCourse.qtdInstallmentsMaterialOmega"() {
      this.updateMaterialInstallmentValue();
    },
    "dataCourse.materialPriceOmega"() {
      this.updateMaterialInstallmentValue();
    },
  },
  beforeDestroy() {
    this.clearInputs();
  }
}

export default mixinCourse